import {EventCustomParameters} from '_types'
import {analyticsEventCustom} from './event-custom'

/**
 * Tracks the click on the "go to cart" button in the minicart.
 */
export function analyticsGoToCart() {
    const eventDetails: EventCustomParameters = {
        category: 'shopping bag',
        action: 'minicart',
        label: 'click',
    }

    analyticsEventCustom(eventDetails)
}
